import { useQuery } from '@apollo/client'
import { WizardStep } from '@factorialco/deprecated-design-system'
import { DatevLaudsFeatureFlagDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

import { businessUnitsStep } from './BusinessUnitsStep'
import { companyStep } from './CompanyStep'
import { loginStep } from './LoginStep'
import { salaryTypesStep } from './SalaryTypesStep'

export const useDatevLaudsSteps = () => {
  const { company } = useCurrentSession()

  const { data } = useQuery(DatevLaudsFeatureFlagDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const offlineAccessTokenEnabled = data?.features?.featuresConnection?.nodes[0]?.enabled ?? false

  let laudsSteps: (() => WizardStep<DatevWizardData>)[] = []
  if (offlineAccessTokenEnabled) {
    laudsSteps = [companyStep, businessUnitsStep, salaryTypesStep]
  } else {
    laudsSteps = [loginStep, companyStep, businessUnitsStep, salaryTypesStep]
  }

  return laudsSteps
}
